import { useEffect } from 'react';

/**
 * Set the document title for the current route.
 *
 * With `useState` navigation there was one title for the whole app, so every
 * tab, every bookmark and every browser history entry read "xinfer". Now that
 * pages are addressable they should be distinguishable too.
 */
export function usePageTitle(title: string, suffix = 'xinfer') {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${suffix}` : suffix;
    return () => {
      document.title = previous;
    };
  }, [title, suffix]);
}
